"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 17.6",
    width: "30",
    height: "17.6"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M29,11.1h-8.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8v-9h-8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5 H29c0.3,0,0.5,0.2,0.5,0.5v10C29.5,10.8,29.3,11.1,29,11.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9.5,11.1H1c-0.3,0-0.5-0.2-0.5-0.5v-10c0-0.3,0.2-0.5,0.5-0.5h8.5c0.3,0,0.5,0.2,0.5,0.5 S9.8,1.1,9.5,1.1h-8v9h8c0.3,0,0.5,0.2,0.5,0.5S9.8,11.1,9.5,11.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M29.5,13.1h-29c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h29c0.3,0,0.5,0.2,0.5,0.5S29.8,13.1,29.5,13.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4,17.6c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C4.5,17.3,4.3,17.6,4,17.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M25.1,16.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M25.1,12.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M27,17.6c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4 C27.5,17.3,27.3,17.6,27,17.6z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "15",
    cy: "4.3",
    r: "4.3"
  }));
};

exports["default"] = _default;